<template>
  <nav
    id="sidebar-navigation"
    class="sidebar-navigation"
  >
    <fn-sidebar-navigation-items
      :nodes="nodes"
      :hide-nav-links-from-crawl="hideNavLinksFromCrawl"
      :display-child-nodes="displayChildNodes"
      :is-account-layout="isAccountLayout"
    />
  </nav>
</template>

<script setup lang="ts">
withDefaults(
  defineProps<{
    nodes: any[];
    hideNavLinksFromCrawl?: boolean;
    displayChildNodes?: boolean;
    isAccountLayout?: boolean;
  }>(),
  {
    hideNavLinksFromCrawl: false,
    displayChildNodes: true,
    nodes: () => [],
    isAccountLayout: false,
  },
);
</script>

<style lang="scss" scoped>
.sidebar-navigation {
  & > .sn-items {
    display: block;
  }
}
</style>
